import React, { useState } from 'react';

import Authentication from "api/Authentication";
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import {
  LOGOUT,
MESSAGE_INFO,
MESSAGE_SUCCES
} from "../../actions/types";
import { connect } from "react-redux";
import { useNavigate,useParams } from 'react-router-dom';

class AccountVerify extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {error: null,isLoaded: false,validation: false};
		this.dispatch = this.props.dispatch;
	}
  
	async componentDidMount() {
		const {verifyKey} = this.props;
		if(verifyKey) {
			let response = await Authentication.verifyAccount(verifyKey);
			if(response && response.status == 200) {
				this.dispatch({ type: MESSAGE_SUCCES, "message": "Uw account is geactiveerd en kunt nu inloggen in uw account.", "header": "Verficatie succesvol" });
				this.props.navigate('login');
				return;				
			}
		}
		
		
		this.dispatch({ type: MESSAGE_INFO, "message": "Verificatie mislukt. Als deze fout zich blijft voordoen neemt u dan contact met ons op!", "header": "Mislukte verficatie" });
		this.props.navigate('login');
		//let response = await Authentication.logoutUser();
		//this.dispatch({ type: LOGOUT });
		//this.props.router.replace('/')
//		window.location.reload();	
		
	}

	render() {
		return null;
	}
}

const Init = (props) => {
	let navigate = useNavigate();
	const params = useParams();
	//return (React.createElement(ComponentName, {...props, navigate:navigate, isLoggedIn: false}))
	//return (<Compo {...props} navigate={navigate}/>)
	return (<AccountVerify {...props} navigate={navigate} {...params}/>)
}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn,
  };
}

export default connect(mapStateToProps)(Init);
